import React, { FunctionComponent, useEffect, useState } from 'react';
import withStyles from 'react-jss';
import { withRouter, match, Link } from 'react-router-dom';
import { pathOr } from 'ramda';
import { compose } from 'recompose';
import { Grid } from 'semantic-ui-react';

import styles from 'scenes/AccountManagement/AccountManagement.styles';
import { AccountDetails } from 'scenes/AccountManagement/AccountManagement.helpers';
import { ClassProp } from 'helpers/types';
import { useCategories } from 'helpers/useCategories';

type Styles = ClassProp<ReturnType<typeof styles>>;

type Props = {
  classes: Styles;
  match: match;
  accountDetails: AccountDetails;
};

const AccountDetails: FunctionComponent<Props> = ({
  classes,
  match,
  accountDetails,
}) => {
  const [categoryText, setCategoryText] = useState<string>('');
  const [subCategoryText, setSubCategoryText] = useState<string>('');

  const {
    getCategoryById,
    getSubCategoryById,
    foundCategory,
    foundSubCategory,
  } = useCategories();

  useEffect(() => {
    const { category, subCategory } = accountDetails;
    if (category) {
      getCategoryById({
        variables: {
          params: {
            id: category,
          },
        },
      });
    }

    if (subCategory) {
      getSubCategoryById({
        variables: {
          params: {
            id: subCategory,
          },
        },
      });
    }
  }, []);

  useEffect(() => {
    const category = foundCategory
      ? pathOr('', ['getCategoryById', 'foundCategory', 'text'], foundCategory)
      : '';
    setCategoryText(category);
  }, [foundCategory]);

  useEffect(() => {
    const subCategory = foundSubCategory
      ? pathOr(
          '',
          ['getCategoryById', 'foundCategory', 'text'],
          foundSubCategory,
        )
      : '';
    setSubCategoryText(subCategory);
  }, [foundSubCategory]);

  return (
    <Grid className={classes.grid}>
      <Grid.Row className={''}>
        <Grid.Column width={6}>
          <div className={classes.clientWrapper}>
            <div className={classes.clientInfo}>
              <h2 className={classes.businessName}>
                {accountDetails.companyName}
              </h2>
              <span>{accountDetails.address1}</span>
              <span>{accountDetails.address2}</span>
              <span className={classes.spacer}>
                {`${accountDetails.city}, ${accountDetails.state} ${accountDetails.postal} `}
              </span>
              <Link
                className={classes.editLink}
                to={`${match.url}/details/update`}
              >
                Edit/Update
              </Link>
            </div>
          </div>
        </Grid.Column>
        <Grid.Column width={5}>
          <div className={classes.fieldGroup}>
            <label className={classes.label}>Business Category:</label>
            {categoryText}
          </div>
          <div className={classes.fieldGroup}>
            <label className={classes.label}>Business Sub-Category:</label>
            {subCategoryText}
          </div>
          <div className={classes.fieldGroup}>
            <label className={classes.label}>Point of Sale System:</label>
            {accountDetails.pointOfSaleSystem}
          </div>
        </Grid.Column>
        <Grid.Column width={5}>
          <div className={classes.fieldGroup}>
            {`${accountDetails.firstName} ${accountDetails.lastName}, ${accountDetails.title}`}
          </div>
          <div className={classes.fieldGroup}>
            <label className={classes.label}>Contact:</label>
            <br />
            <a href="mailto:#">{accountDetails.email}</a>
            <br />
            <span>{accountDetails.phone}</span>
          </div>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default compose<Props, any>(
  withStyles(styles),
  withRouter,
)(AccountDetails);
